import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/Header";

export default function RegisterPage() {
  const { register } = useAuth() || {};
  const [form, setForm] = useState({ full_name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const onChange = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await register(form);
      navigate("/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Erreur lors de la création du compte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-lokaso-sand flex items-center justify-center px-4 py-16" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8"><Logo /></div>
        <div className="bg-white rounded-2xl border border-stone-200 shadow-lg p-8">
          <h1 className="font-display text-3xl font-bold text-center">Créer un compte</h1>
          <p className="text-center text-stone-600 mt-1">Rejoignez la communauté Lokaso</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="register-form">
            {[
              { k: "full_name", label: "Nom complet", type: "text", placeholder: "Mamadou Diallo" },
              { k: "email", label: "Email", type: "email", placeholder: "vous@exemple.gn" },
              { k: "phone", label: "Téléphone", type: "tel", placeholder: "+224 ..." },
              { k: "password", label: "Mot de passe", type: "password", placeholder: "8 caractères minimum" },
            ].map((f) => (
              <div key={f.k}>
                <label className="text-xs uppercase tracking-wider font-semibold text-stone-500">{f.label}</label>
                <input
                  type={f.type}
                  required={f.k !== "phone"}
                  value={form[f.k]}
                  onChange={onChange(f.k)}
                  placeholder={f.placeholder}
                  className="mt-1 w-full h-12 px-4 rounded-xl border border-stone-200 focus:outline-none focus:ring-2 focus:ring-lokaso-green"
                  data-testid={`register-${f.k}-input`}
                />
              </div>
            ))}
            {err && <p className="text-sm text-lokaso-red" data-testid="register-error">{err}</p>}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="register-submit-btn">
              {loading ? "Création…" : "Créer mon compte"}
            </button>
          </form>

          <p className="mt-6 text-sm text-center text-stone-600">
            Déjà un compte ?{" "}
            <Link to="/login" className="text-lokaso-red font-semibold hover:underline" data-testid="register-login-link">Se connecter</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
